export default "__VITE_ASSET__38530069__"